import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import type { AttachmentDto } from '@/services/ws-funnel/src/main/resources/rest-api';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Icons, Table } from '@/js/libs/ui';

type AttachmentRowProps = {
  attachment: AttachmentDto;
  onDelete: (attachment: AttachmentDto) => void;
  onDownload: (attachment: AttachmentDto) => void;
  pendingDownloadFile: boolean;
};

export const AttachmentRow = memo(function AttachmentRow({ attachment, onDelete, onDownload, pendingDownloadFile }: AttachmentRowProps) {
  const [t] = useTranslation(['backend', 'common']);

  const handleDelete = useCallbackRef(() => {
    onDelete(attachment);
  });

  const handleDownload = useCallbackRef(() => {
    onDownload(attachment);
  });

  return (
    <Table.Tr>
      <Table.Td>{attachment.name}</Table.Td>
      <Table.Td type='action'>
        <Table.ActionsList>
          <Table.ActionsListItem onClick={handleDelete} remove icon={<Icons.Trash />}>
            <div>{t('common:DELETE')}</div>
          </Table.ActionsListItem>
          <Table.ActionsListItem
            onClick={handleDownload}
            disabled={!attachment.fileId}
            isLoading={pendingDownloadFile}
            icon={<Icons.Download />}>
            {t('common:DOWNLOAD')}
          </Table.ActionsListItem>
        </Table.ActionsList>
      </Table.Td>
    </Table.Tr>
  );
});
